import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import {
  GET_GAMIFICATION_BADGES,
  GET_GAMIFICATION_LEADERBOARD,
  GET_GAMIFICATION_PROFILE,
  getGamificationBadgesAction,
  getGamificationLeaderboardAction,
  storeGamificationBadgesAction,
  storeGamificationLeaderboardAction,
  storeGamificationProfileAction,
} from '../actions/gamification.actions';
import { map, switchMap } from 'rxjs/operators';
import { GamificationService } from '../gamification.service';
import { GamificationProfileDto } from '../types/GamificationProfileDto';
import { GamificationActivityType } from '../types/gamification-activity-type';
import { formatToTimeZone } from 'date-fns-timezone';
import { PayloadAction } from '../types/payload-action';
import { GamificationBadgeDto } from '../types/GamificationBadgeDto';
import { GamificationLeaderboardDto } from '../types/GamificationLeaderboardDto';
import { OeAppPersonService } from '../oe-app-person.service';

@Injectable()
export class GamificationEffects {
  constructor(
    private actions$: Actions,
    private gamificationService: GamificationService,
    private oeAppPersonService: OeAppPersonService
  ) {}

  @Effect()
  getGamificationProfile: Observable<Action> = this.actions$.pipe(
    ofType(GET_GAMIFICATION_PROFILE),
    switchMap(() =>
      this.gamificationService.getGameProfile(
        this.oeAppPersonService.contactId
      )
    ),
    switchMap((data: GamificationProfileDto) => {
      const returnActions: Action[] = [storeGamificationProfileAction(data)];

      if (data) {
        // There is a valid gamification profile
        returnActions.push(
          getGamificationBadgesAction(
            GamificationActivityType.COMPLETE_WEEKLY_CHALLENGE,
            formatToTimeZone(new Date(), 'MMDDYYYY', { timeZone: 'EST' })
          ),
          getGamificationLeaderboardAction(this.oeAppPersonService.contactId)
        );
      }

      return returnActions;
    })
  );

  @Effect()
  getGamificationBadges: Observable<Action> = this.actions$.pipe(
    ofType(GET_GAMIFICATION_BADGES),
    switchMap(
      (
        data: PayloadAction<{
          activityType: GamificationActivityType;
          forDate?: string;
        }>
      ) =>
        this.gamificationService.getActivityBadges(
          data.payload.activityType,
          data.payload.forDate
        )
    ),
    map((data: GamificationBadgeDto[]) => storeGamificationBadgesAction(data))
  );

  @Effect()
  getGamificationLeaderboard: Observable<Action> = this.actions$.pipe(
    ofType(GET_GAMIFICATION_LEADERBOARD),
    switchMap((data: PayloadAction<string>) =>
      this.gamificationService.getLeaderboard(data.payload)
    ),
    map((data: GamificationLeaderboardDto) => {
      if (data) {
        const contactId = this.oeAppPersonService.contactId;
        const currentMember = data.members.find(
          (e) => e.contactId === contactId
        );

        if (currentMember) {
          currentMember.currentUser = true;
        }
      }

      return storeGamificationLeaderboardAction(data);
    })
  );
}



// WEBPACK FOOTER //
// ./ts/app/shared/effects/gamification.effects.ts